import validate from 'mixins/validate';

export default {
  props: {
    name: String,
    dynamicName: String,
    refValue: String,
    namespace: {
      type: String,
      default: '',
    },
    label: String,
    dynamicLabel: Function,
    modifier: {
      type: String,
      default: 'default',
    },
    placeholder: String,
    optionsJson: String,
    dynamicOptionsJson: Array,
    optionsFunction: Function,
    initialValueGetter: Function,
    error: String,
    required: Boolean,
    validateMethod: Function,
  },
  data() {
    const data = {
      fieldName: this.dynamicName || this.name,
      isValid: false,
      isActive: false,
      isFocus: false,
      showErrorMessage: false,
      selectedText: '',
      inputValue: '',
    };
    return data;
  },
  watch: {
    inputValue() {
      this.validateInput();
      this.selectedText = this.optionsObject[this.inputValue];
      this.$emit('change', {
        value: this.inputValue,
        name: this.name,
      });
      this.$emit('value-change', {
        value: this.inputValue,
        name: this.name,
      });
    },
  },
  mounted() {
    if (
      this.initialValueGetter &&
      typeof this.initialValueGetter === 'function'
    ) {
      this.inputValue = this.initialValueGetter(this.name);

      if (this.inputValue) {
        this.isActive = true;
        this.isFocus = true;
        this.unsetActive();
        this.selectedText = this.optionsObject[this.inputValue];
      }
    }

    this.$emit('value-change', {
      value: this.inputValue,
      name: this.name,
    });
    this.$emit('change', {
      value: this.inputValue,
      name: this.name,
    });
  },
  computed: {
    labelStr() {
      if (this.dynamicLabel && typeof this.dynamicLabel === 'function') {
        return this.dynamicLabel(this.name);
      } else if (this.label) {
        return this.label;
      } else if (this.placeholder) {
        return this.placeholder;
      }
    },
    options() {
      if (this.optionsJson) {
        try {
          return JSON.parse(this.optionsJson);
        } catch (error) {
          return [];
        }
      }
      if (this.dynamicOptionsJson) {
        return this.dynamicOptionsJson;
      }
      if (this.optionsFunction && typeof this.optionsFunction === 'function') {
        return this.optionsFunction();
      }

      return [];
    },
    optionsHTML() {
      let html = '';
      if (this.placeholder) {
        html += `<option value="" disabled selected>${this.placeholder}</option>`;
      }
      this.options.forEach((item) => {
        html += `<option value="${item.value}"${
          item.enabled ? '' : ' disabled'
        }>${item.label}</option>`;
      });

      return html;
    },
    optionsObject() {
      const object = {};

      for (const option of this.options) {
        object[option.value] = option.label;
      }

      return object;
    },
  },
  methods: {
    onChange() {
      this.$emit('value-change', {
        value: this.inputValue,
        name: this.name,
      });
      this.$emit('change', {
        value: this.inputValue,
        name: this.name,
      });
    },
    setActive() {
      this.isActive = true;
      this.isFocus = true;
      this.validateInput();
    },
    unsetActive() {
      if (!this.inputValue) {
        this.isActive = false;
      }
      this.isFocus = false;
      this.validateInput();
    },
    getDynamicClasses() {
      const classes = [];
      if (this.isActive) {
        classes.push('is-active');
        if (!this.isValid && !this.isFocus) {
          classes.push('form-row__error');
        }
      }
      if (this.isFocus) {
        classes.push('is-focus');
      }
      return classes.join(' ');
    },
    refresh() {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value;
        if (this.inputValue) this.setActive();
      }, 0);
    },
  },
  mixins: [validate],
  template: `
  <div class="dropdown-menu"
    :class="['dropdown-menu--'+modifier, getDynamicClasses() ]">
    <div class="dropdown-menu__wrapper">
      <select
        class="dropdown-menu__el"
        :name="fieldName"
        :id="fieldName"
        :ref="refValue"
        v-model="inputValue"
        v-on:change="setActive"
        v-on:click="setActive"
        v-on:focus="setActive"
        v-on:blur="unsetActive"
        v-html="optionsHTML">
      </select>
      <label
      :for="fieldName"
      :class="['dropdown-menu__label', (isActive)?'is-active': '']"
      >{{ labelStr }}</label>
      <div class="dropdown-menu__arrow">
        <svg  class="w1" viewBox="0 0 14 9">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-down" x="0" y="0"></use>
        </svg>
    </div>
      <div class="dropdown-menu__value">{{(selectedText)}}</div>
    </div>
    <p v-if="!isValid" class="dropdown-menu__error form-row__error__text-error red">{{error}}</p>
  </div>`,
};
